var e;!function(e){e.OTP="OTP",e.EMAIL="EMAIL",e.PROFILE="PROFILE",e.ABOUT_SELF="ABOUT_SELF"}(e||(e={}));var L="Trouble receiving code? Get a Magic Link instead.";export{e as AuthenticationVariant,L as MAGIC_LINK_BTN_TEXT};
//# sourceMappingURL=authentication.types.js.map
